<template>
  <svg class="app-ctrl-svg-icon" xmlns="http://www.w3.org/2000/svg" width="40.642" height="35.408" viewBox="0 0 40.642 35.408">
    <g id="Gruppe_63" data-name="Gruppe 63" transform="translate(3.361 3.408)">
      <path id="Icon_feather-star" data-name="Icon feather-star" d="M10.5,3l2.317,4.695L18,8.452,14.25,12.1l.885,5.16L10.5,14.827,5.865,17.264,6.75,12.1,3,8.452l5.182-.757Z" transform="translate(18.031 -5.158)" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"/>
      <g id="Logo" transform="translate(-662.361 -665.489)">
        <path id="Pfad_58" data-name="Pfad 58" d="M8552.109,2872h-10.922l-2.084,4.094-2.514,2.124s-1.918,4.629-1.938,4.7.021,9.467,0,9.381,21.063,0,21.063,0h14.87v-8.574" transform="translate(-7873.828 -2202.767)" fill="none" stroke-width="2.5"/>
        <line id="Linie_88" data-name="Linie 88" x2="23.445" transform="translate(666.815 691.501)" fill="none" stroke-width="2"/>
        <path id="Pfad_59" data-name="Pfad 59" d="M0,0,5.972,1.706V3.242H0Z" transform="translate(664.119 680.892)" />
        <path id="Pfad_60" data-name="Pfad 60" d="M5.972,0,0,1.706V3.242H5.972Z" transform="translate(688.006 680.892)" />
        <path id="Rechteck_236" data-name="Rechteck 236" d="M0,0H14.513a0,0,0,0,1,0,0V0a4.466,4.466,0,0,1-4.466,4.466H4.466A4.466,4.466,0,0,1,0,0V0A0,0,0,0,1,0,0Z" transform="translate(671.28 682.734)" />
        <g id="Rechteck_237" data-name="Rechteck 237" transform="translate(659 692.489)" stroke-width="1">
          <rect width="8" height="5" stroke="none"/>
          <rect x="0.5" y="0.5" width="7" height="4" fill="none"/>
        </g>
        <g id="Rechteck_238" data-name="Rechteck 238" transform="translate(690 692.489)" stroke-width="1">
          <rect width="8" height="5" stroke="none"/>
          <rect x="0.5" y="0.5" width="7" height="4" fill="none"/>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {

}
</script>

<style>

</style>